module.exports = __webpack_public_path__ + "static/media/grundriss_balkon.95858195.gif";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/projekte/grundriss_balkon.gif
// module id = 359
// module chunks = 0